import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const LOCALES = [
  { value: 'pt-BR', label: 'Português Brasil',   flag: '🇧🇷', short: 'BR', country: 'Brasil' },
  { value: 'pt-PT', label: 'Português Portugal',  flag: '🇵🇹', short: 'PT', country: 'Portugal' },
]

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref(localStorage.getItem('app-locale') || 'pt-BR')

  function setLocale(val) {
    locale.value = val
    localStorage.setItem('app-locale', val)
  }

  function toggleLocale() {
    const idx = LOCALES.findIndex(l => l.value === locale.value)
    setLocale(LOCALES[(idx + 1) % LOCALES.length].value)
  }

  const current = computed(() => LOCALES.find(l => l.value === locale.value) || LOCALES[0])

  return { locale, setLocale, toggleLocale, current }
})
